// eslint-disable-next-line @nx/enforce-module-boundaries
import { SocketSubscription } from '@mode/shared/data-access-socket';
import { createAction, props } from '@ngrx/store';
import { CreateExcelSheetProps } from './create-sheet-props';
import { ExcelSheetRunPusherSuccessPayload } from './excel-types';

export const createExcelSheetDataset = createAction(
  '[Dataset] CREATE_EXCEL_SHEET_DATASET',
  props<CreateExcelSheetProps>()
);

export const createExcelSheetDatasetSuccess = createAction(
  '[Dataset] CREATE_EXCEL_SHEET_DATASET_SUCCESS',
  props<{ reportRunToken: string; channelName: string }>()
);

export const createExcelSheetDatasetFailed = createAction('[Dataset] CREATE_EXCEL_SHEET_DATASET_FAILED');

export const excelSheetSocketConnectionSuccess = createAction(
  '[Dataset] CREATE_EXCEL_SHEET_SOCKET_CONNECTION_SUCCESS',
  props<{
    reportRunToken: string;
    excelSheetSubscription: SocketSubscription<ExcelSheetRunPusherSuccessPayload>;
  }>()
);

export const ingestExcelSheetEnqueued = createAction(
  '[Dataset] INGEST_EXCEL_SHEET_ENQUEUED',
  props<{ reportRunToken: string }>()
);

export const ingestExcelSheetInProgresss = createAction(
  '[Dataset] INGEST_EXCEL_SHEET_IN_PROGRESS',
  props<{ token: string; progressToastId: number }>()
);

export const ingestExcelSheetSuccess = createAction(
  '[Dataset] INGEST_EXCEL_SHEET_SUCCESS',
  props<{ token: string; datasetToken: string; editDatasetLink: string }>()
);

export const afterIngestExcelSheetSuccess = createAction(
  '[Dataset] AFTER_INGEST_EXCEL_SHEET_SUCCESS',
  props<{ datasetToken: string }>()
);

export const ingestExcelSheetFailed = createAction(
  '[Dataset] INGEST_EXCEL_SHEET_FAILED',
  props<{ token: string; editDatasetLink: string }>()
);
